import { WOOT_PREFIX } from './constants';

export const isEmptyObject = obj =>
  Object.keys(obj).length === 0 && obj.constructor === Object;

export const sendMessage = msg => {
  window.parent.postMessage(
    `chatwoot-widget:${JSON.stringify({ ...msg })}`,
    '*'
  );
};

export const createGreetingMessages = () => {
  const msgs = [];

  const { greetingEnabled, assistantType } = window.hooryWebChannel;
  if (assistantType !== 'rule-based' && greetingEnabled) {
    msgs.push({
      id: 0,
      content: window.hooryWebChannel.greetingMessage,
      created_at: new Date().getTime() / 1000,
      message_type: 3,
      content_type: 'text',
      content_attributes: {},
      source_id: 'widget',
    });
  }

  const { typebotGreetingMessages } = window.hooryWebChannel;
  if (typeof typebotGreetingMessages !== 'undefined') {
    typebotGreetingMessages.forEach((msg, index) => {
      const { data } = msg;
      let content = {
        id: index + 1,
        content: data.content,
        created_at: new Date().getTime() / 1000,
        content_attributes: data.content_attributes || {},
        message_type: 1,
        source_id: data.source_id,
        // ? @is_greeting_message used for RB
        is_greeting_message: true,
        sender: {
          assistant_type: 'rule-based',
        },
      };
      if (msg.method === 'send-text-message') {
        content.content_type = 'text';
        content = { ...content, content_type: 'text' };
      } else if (msg.method === 'send-media-message') {
        content.content_type = 'cards';
      } else if (msg.method === 'send-embed-message') {
        content.content_type = 'article';
      } else {
        content = {
          content_type: 'form',
          ...content,
          ...msg,
        };
      }
      msgs.push(content);
    });
  }

  return msgs;
};

export const IFrameHelper = {
  isIFrame: () => window.self !== window.top,
  sendMessage,
  isAValidEvent: e => {
    const isDataAString = typeof e.data === 'string';
    return isDataAString && e.data.indexOf(WOOT_PREFIX) === 0;
  },
  getMessage: e => {
    const json = e.data.replace(WOOT_PREFIX, '');
    // check if is json parsable
    try {
      if (json) return JSON.parse(json);
      // eslint-disable-next-line no-empty,no-shadow
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('Error parsing PostMessage JSON');
    }

    return {};
  },
};
export const RNHelper = {
  isRNWebView: () => window.ReactNativeWebView,
  sendMessage: msg => {
    window.ReactNativeWebView.postMessage(
      `chatwoot-widget:${JSON.stringify({ ...msg })}`
    );
  },
};

export const groupBy = (array, predicate) => {
  return array.reduce((acc, value) => {
    (acc[predicate(value)] ||= []).push(value);
    return acc;
  }, {});
};
